import React from 'react'

const Layout = React.lazy(() => import('./Layout'))
const DefaultPage = React.lazy(() => import('./DefaultPage'))

export default {
  path: 'broadcast',
  name: 'Broadcast',
  component: Layout,
  childRoutes: [
    { path: 'default-page', name: 'Default page', component: DefaultPage, isIndex: true },
  ],
};



// WEBPACK FOOTER //
// ./src/features/broadcast/route.js